import { render, staticRenderFns } from "./AppItemAdd.vue?vue&type=template&id=222486f4"
import script from "./AppItemAdd.vue?vue&type=script&lang=js"
export * from "./AppItemAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\nakatsukasa\\Herd\\cms.insag\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('222486f4')) {
      api.createRecord('222486f4', component.options)
    } else {
      api.reload('222486f4', component.options)
    }
    module.hot.accept("./AppItemAdd.vue?vue&type=template&id=222486f4", function () {
      api.rerender('222486f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/common/components/AppItemAdd.vue"
export default component.exports